import { apiClient } from './api';
import type { Tag } from '@/types';

/** Payload for creating a tag. The slug is the identity and is set once. */
export interface CreateTagRequest {
  slug: string;
  displayName: string;
  dimension: string;
  sortOrder?: number;
}

/** Everything except the slug, which is immutable — renaming means displayName. */
export interface UpdateTagRequest {
  displayName?: string;
  dimension?: string;
  sortOrder?: number;
  isActive?: boolean;
}

export class TagAPI {
  static async getAll(includeInactive = false): Promise<Tag[]> {
    return apiClient.get<Tag[]>('/tags', {
      includeInactive: includeInactive.toString(),
    });
  }

  static async getBySlug(slug: string): Promise<Tag> {
    return apiClient.get<Tag>(`/tags/${slug}`);
  }

  static async create(data: CreateTagRequest): Promise<Tag> {
    return apiClient.post<Tag>('/tags', data);
  }

  static async update(slug: string, data: UpdateTagRequest): Promise<Tag> {
    return apiClient.put<Tag>(`/tags/${slug}`, data);
  }

  static async remove(slug: string): Promise<{ success: boolean; message: string }> {
    return apiClient.delete(`/tags/${slug}`);
  }
}
